/**
 * @generated SignedSource<<57385a6fc99e77551ddf266c95ccbb22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgWorkspaceAdminQuery$variables = {
  workspaceId: string;
};
export type OrgWorkspaceAdminQuery$data = {
  readonly viewer: {
    readonly workspaces: ReadonlyArray<{
      readonly id: string;
      readonly parentId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelector_workspaces">;
    }> | null;
  } | null;
  readonly workspace: {
    readonly id: string;
    readonly name: string;
    readonly parentId: string | null;
  };
};
export type OrgWorkspaceAdminQuery = {
  response: OrgWorkspaceAdminQuery$data;
  variables: OrgWorkspaceAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgWorkspaceAdminQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSelector_workspaces"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgWorkspaceAdminQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9383962a649c707aa98ff197cff9385e",
    "id": null,
    "metadata": {},
    "name": "OrgWorkspaceAdminQuery",
    "operationKind": "query",
    "text": "query OrgWorkspaceAdminQuery(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    id\n    name\n    parentId\n  }\n  viewer {\n    workspaces {\n      parentId\n      id\n      ...WorkspaceSelector_workspaces\n    }\n  }\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n\nfragment WorkspaceSelector_workspaces on Workspace {\n  id\n  name\n  parentId\n  ...WorkspaceSelectorContent_workspaces\n}\n"
  }
};
})();

(node as any).hash = "69b919087bb7c501b5c49b11b6bbb6a8";

export default node;
